<div *ngIf="(isAuthenticated$ | async)">
  <div class="container-head">
    <div class="is-relative" style="height: 52px; background:red;">
      <div class="is-flex-tablet container-head1" style="">
        <div *ngIf="isMenu" class="container-logo pt-2 pl-4" >
          <div class="is-flex-grow-1">
           <!-- <img *ngIf="isDicom()" src="../../../../assets/design/logo-gesoft.jpg" clasS="mt-1" style="max-height: 30px;"/>-->
            <img  src="../../../../assets/design/iw_logo.svg" class="logo mt-2" style="color:#000; max-height: 20px;"/><!--
            <img  *ngIf="!isDicom()" src="../../../../assets/design/iw-logo-white.svg" class="mt-2" style="color:#000; max-height: 20px;"/>-->
          </div>
        </div>
        <div class="is-flex is-flex-grow-3" [style.background-color]="isProduction() ? '': '#ff0000'" style="box-shadow: 0 4px 2px -2px #dadada;">
          <div>
            <div class="toggle-menu-left mt-2 is-size-5 ml-4 is-pointer" (click)="toggleMenu()">
              <fa-icon [icon]="faBars"  class="ml-2"></fa-icon><br>
            </div>
          </div>
          <div class="is-flex-grow-3">
            <div class="container-user is-flex p-2 mr-2 ml-4 ">
              <div class="is-size-7 mr-4 pr-3" style="border-right: 1px solid #c0c0c0;">
                <b> <fa-icon [icon]="faUser"*ngIf="!logoutLoading" class="mr-1"></fa-icon>
                  <span *ngIf="user$ | async as data">
                  {{ data.username}}
                  </span>
                </b><br>
                <a href="{{(global$ | async)?.backendIdentifier}}" target="_blank">{{(global$ | async)?.backendIdentifier}}</a>
              </div>
              <div>
                <a class=" logout is-size-4" (click)="logout()">
                  <button *ngIf="logoutLoading" class="button is-loading ml-2"></button>
                  <fa-icon [icon]="faSignOut" *ngIf="!logoutLoading" class="ml-2"></fa-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="is-flex" style="height: calc(100vh - 52px);">
    <div class="container-menu" [ngClass]="isMenu ? 'is-menu' : 'is-menu-hidden'">
     <!-- <app-menu></app-menu>-->
      <ng-content select=".iw-menu"></ng-content>
    </div>
    <div class="container-content m-3 p-3" [ngClass]="{'is-menu': isMenu, 'is-taskbar': (isTaskbar$ | async)?.length}">
      <ng-content select=".iw-content"></ng-content>
    </div>
  </div>

  <div #windows></div>
</div>


